import GlobalVariable from '@/global/global-variable'

// 查询消息
const searchNotice = GlobalVariable.BASE_PATH + "/rest/notice/find";

export default {
    // 查询消息
    searchNotice,
}



// WEBPACK FOOTER //
// ./src/request/api-notice.js